@let headerName = this.headerName();
@let showAppSpecificMenu = this.showAppSpecificMenu();
@let hideLanguage = this.hideLanguage();
@let showWaremaAGB = this.showWaremaAGB();
@let showLoginControls = this.showLoginControls();
@let isLoggedIn = this.isLoggedIn();
@let version = this.version();
@let appName = this.appName();
@let hideShopLinks = this.hideShopLinks();
@let tenantConfigSettings = this.tenantConfigSettings();
@let showCountryMenu = this.showCountryMenu();

<warema-header-menu class="shared-burger-menu" id="shared-burger-menu" trigger-id="shared-burger-menu">
    <warema-header-menu-headline [headline]="headerName" />

    @if (showAppSpecificMenu) {
        <ng-content />

        <warema-header-menu-headline [headline]="'SHARED_MENU_IN_GENERAL' | translate" />
    }

    <warema-header-menu-item
        trigger-for="overview-all-tools"
        [icon]="'tiles'"
        [label]="'SHARED_MENU_OVERVIEW_ALL_TOOLS' | translate"
    />

    @if (hideLanguage === false) {
        <warema-header-menu-item
            trigger-for="change-language"
            [icon]="'globe'"
            [label]="
                'SHARED_MENU_LANGUAGE'
                    | translate
                        : { language: ('LANGUAGE_' + (translateService.getCurrentLang() | uppercase) | translate) }
            "
        />
    }
    @if (showWaremaAGB) {
        <warema-header-menu-item
            [icon]="'documentTerms'"
            [label]="'SHARED_MENU_GENERAL_TERMS_AND_CONDITIONS' | translate"
            (click)="clickUrl.emit([translateService.instant('SHARED_MENU_GENERAL_TERMS_AND_CONDITIONS_URL'), true])"
        />
    }
    <warema-header-menu-item
        [icon]="'paragraph'"
        [label]="'SHARED_MENU_DATA_PROTECTION_AND_IMPRINT' | translate"
        (click)="clickUrl.emit([translateService.instant('SHARED_MENU_DATA_PROTECTION_AND_IMPRINT_URL'), true])"
    />

    @if (showLoginControls) {
        @if (!isLoggedIn) {
            <warema-header-menu-item
                id="login-button"
                [icon]="'person'"
                [label]="'LOGIN' | translate"
                (click)="login.emit(true)"
            />
        }
        @if (isLoggedIn) {
            <warema-header-menu-item
                id="logout-button"
                [icon]="'logout'"
                [label]="'LOGOUT' | translate"
                (click)="logout.emit(true)"
            />
        }
    }

    <warema-header-menu-item icon="info" [disabled]="true" [label]="('VERSION' | translate) + ' ' + version" />
</warema-header-menu>

<ng-content select="[slot=submenus]" />

<warema-header-menu
    class="shared-burger-menu"
    id="shared-overview-all-tools"
    parent-menu-id="shared-burger-menu"
    trigger-id="overview-all-tools"
    [navigateBackText]="'BACK' | translate"
>
    <warema-shared-header-submenu-tools
        [appName]="appName"
        [firstRouteSegment]="firstRouteSegment"
        [hideShopLinks]="hideShopLinks"
        [tenantConfigSettings]="tenantConfigSettings!"
        (clickRouteRedirect)="clickRouteRedirect.emit($event)"
        (clickUrl)="clickUrl.emit([$event, false])"
    />
</warema-header-menu>

<warema-header-menu
    class="shared-burger-menu"
    id="shared-change-language"
    parent-menu-id="shared-burger-menu"
    trigger-id="change-language"
    [navigateBackText]="'BACK' | translate"
>
    <warema-shared-header-submenu-language
        [appName]="appName"
        [isLoggedIn]="isLoggedIn"
        [showCountryMenu]="showCountryMenu"
        [tenantConfigSettings]="tenantConfigSettings!"
        (setLanguage)="setLanguage.emit($event)"
    />
</warema-header-menu>
